<template>
  <SimpleCrud
    :title_md="9"
    :sc_btns_md="3"
    :headers="headers"
    :name="name"
    :scheme="scheme"
    :canWrite="!disabled"
    :canDetail="false"
    :canAdd="!disabled"
    :canDelete="!disabled"
    :merge_new_item="merge_item"
    :logicDelete="false"
    :no_title="no_title"
    @open-file="open_auth_file">
    <template slot="crud-title">
      <slot name="crud-title">
        <h5 :style="`color:${dark_t?'white':'black'}`">{{title || "Documentos Adjuntos"}}</h5>
      </slot>
    </template>
    <template slot="write-title">Documento</template>
    <template v-slot:document="{ item, value }">
      <fs1 tag="td" class="width150px">
        <v-progress-circular v-if="is_auth_file_opening(item)" indeterminate color="primary" size="20" width="2"/>
        <v-icon v-else-if="resolveAuthFileUrl(item)" class="pointer_hover" @click="open_auth_file(item)">insert_drive_file</v-icon>
        <a v-else-if="(value || item.file_name) && !isProtectedUploadUrl(value || item.file_name)" :href="value || item.file_name" target="_blank" class="tableM1_file">
          <v-icon>insert_drive_file</v-icon>
        </a>
      </fs1>
    </template>
    <template slot-scope="{ selectedItem }" slot="write">
        <table style="width: 100%;">
          <tr>
            <td class="pa-2"><b>Nombre</b></td>
            <td class="pa-2">
              <in-text v-model="selectedItem.name" placeholder=" ingresar texto" :condensed="true"/>
            </td>
            <td class="pa-2">
              <v-icon @click="selectedItem.name = null">clear</v-icon>  
            </td>
          </tr>
          <tr>
            <td class="pa-2"><b>Archivo</b></td>
            <td class="pa-2">
              <in-file :value.sync="selectedItem.document"/>
            </td>
            <td class="pa-2"><v-icon @click="selectedItem.status=0;selectedItem.document = null">clear</v-icon></td>
          </tr>
        </table>
    </template>
  </SimpleCrud>
</template>
<script>
import {v4 as uuid} from 'uuid';
import filter from '@/components/mixins/filter';
import open_auth_file from '@/mixins/open_auth_file';
export default {
  mixins:[filter, open_auth_file],
  name:'t-files',
  props:['name','disabled','merge_item','ex_filters','title','no_title','config_name'],
  data(){
    return {
      id: uuid(),
      scheme: {
        name: {type: 'string'},
        document: {type: 'file'},
        belongs_to: {type:'int'},
        type: {type: 'string'},
        status: {type: 'int'},
      }
    }
  },
  computed: {
    headers() {
      const hs = [
        { text: 'Nombre del documento', value:'name', class: 'text_align_left'},
        { text: 'Archivo', value:'document', class: 'width150px',  align:'center'},
      ]
      if (!this.disabled) hs.push({ text: '',value: 'actions', class: 'width100px'});
      return hs;
    },
    rq_name() {return this.config_name || this.name},
  },
  watch:{
    'ex_filters':{
      deep: true,
      handler(v){ 
        if (!this.filter || !v) return;
        const keys = Object.keys(this.filter);
        if (keys.find(k=>this.filter[k]!=v[k])/* this.filter.f__belongs_to != v.f__belongs_to */) this.get_data();
      }
    },
  },
  created() {
    this.get_data();
  },
  methods: {
    selectFile(item, files) { // files no es un array por lo que sus proto funciones no aplican
      item./* file */document = files[0]
      item.status = 1;
      const reader = new FileReader();
      reader.onload = e => item.status = 2;
      reader.readAsDataURL(files[0]);
		},
    resetRqStatus(){
      this.myRequestStatus.status = false;
      this.myRequestStatus.ticking = false;
    },
    get_data(){
      if (this.myRequestStatus) this.resetRqStatus();
      Object.assign(this.filter, this.ex_filters);
      const filter = {...this.filter};
      Object.keys(filter).forEach(k => [undefined,null].includes(filter[k]) && (delete filter[k]));
      this.requests.gets[`${this.config_name || this.name}/a/all`](filter);
    }
  },
};
</script>
